<template>
    <span class="radio-icon" :class="getRadioColor(radio)">
    </span>
</template>
<script>

export default {
    name: 'RadioIcon',
    props: {
        radio: {
            type: Number,
            default: 0
        },
        lostConnection: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getRadioColor(radio) {
            if (this.lostConnection) {
                return 'lost';
            }
            if (radio >= 55) {
                return 'full';
            } else if(radio >= 5){
                return 'low';
            }else {
                return 'out';
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.radio-icon{
    width: 20px;
    height: 20px;
    &.full{
        @include background($image: img('wifi_full.svg'), $size: 20px, $position: center center);
    }
    &.low{
        @include background($image: img('wifi_low.svg'), $size: 20px, $position: center center);
    }
    &.out{
        @include background($image: img('wifi_out.svg'), $size: 20px, $position: center center);
    }
    &.lost{
        background-color: $error-dark;
        -webkit-mask-image: img('wifi_out.svg');
        mask-image: img('wifi_out.svg');
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;
        -webkit-mask-position: center;
        mask-position: center;
        -webkit-mask-size: 20px 20px;
        mask-size: 20px 20px;
    }
}
</style>